import { queryOptions } from '@tanstack/react-query';
import {
  calculateGroundRoute,
  CalculateGroundRouteParams,
  getAddressByReverseGeocode,
  fetchGeocode,
} from '@/api/apis/here-maps';
import { hereMapsQueryKeys } from '@/queries/here-maps/here-maps.keys';

export const hereMapsQueries = {
  getGroundRoute: ({ startLocation, endLocation, type, timestamp }: CalculateGroundRouteParams) =>
    queryOptions({
      queryKey: hereMapsQueryKeys.getGround(startLocation, endLocation, type, timestamp),
      queryFn: () => calculateGroundRoute({ startLocation, endLocation, type, timestamp }),
      staleTime: Infinity,
    }),
  getAddressByReverseGeocode: (coords: number[]) =>
    queryOptions({
      queryKey: hereMapsQueryKeys.getAddressByGeocode(coords),
      queryFn: () => getAddressByReverseGeocode(coords),
      staleTime: Infinity,
    }),
  getGeocode: ({ country, state }: { country: string; state?: string }) =>
    queryOptions({
      queryKey: hereMapsQueryKeys.getGeocode(country, state),
      queryFn: () => fetchGeocode({ country, state }),
      staleTime: Infinity,
    }),
};
